/* Dansk katalog for locale-investment-inbox.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'investments.inboxTitle': 'Indbakke',
  'investments.inboxIntro': 'Upload dokumenter for køb og salg af fonde og aktier. Plumme læser dokumentet og klargør registreringen.',
  'investments.supportNotice': 'Fonde og aktier understøttes fuldt ud til registrering og bogføring. Andre investeringstyper kan genkendes, men skal indtil videre behandles manuelt.',
  'investments.sendToEmail': 'Send til',
  'investments.copyEmail': 'Kopiér e-mailadresse',
  'investments.folder': 'Mappe',
  'investments.inboxFolder': 'Indbakke',
  'investments.trashFolder': 'Papirkurv',
  'investments.documentationFolder': 'Dokumentation',
  'investments.searchDocuments': 'Søg i dokumenter',
  'investments.emptyFolder': 'Der er ingen dokumenter i denne mappe.',
  'investments.documentNotAnalyzed': 'Klar til analyse',
  'investments.superPlummaProposal': 'Forslag fra SuperPlumma',
  'investments.reviewAndApprove': 'Kontrollér og godkend',
  'investments.notAnalyzedHelp': 'Dokumentet er modtaget og klar til analyse.',
  'investments.restoreDocument': 'Gendan',
  'investments.sendToDocumentation': 'Send til dokumentation',
  'investments.moveToTrash': 'Flyt til papirkurven',
  'investments.moreActions': 'Flere handlinger',
  'investments.registerPurchase': 'Registrér køb',
  'investments.registerSale': 'Registrér salg',
  'investments.tradeDate': 'Handelsdato',
  'investments.unitPrice': 'NAV / kurs',
  'investments.previewDocumentFallback': 'Dokument',
  'investments.previewMissingFileLink': 'Mangler fillink',
  'investments.openDocument': 'Åbn dokument',
  'investments.addBankAccount': '+ Tilføj bankkonto …',
  'investments.addBankTitle': 'Tilføj bankkonto',
  'investments.addBankSave': 'Tilføj konto',
  'investments.newBankAccountNote': 'Ny bankkonto oprettes i kontoplanen',
  'investments.newBankAccountCode': 'Bankkontoen får den næste ledige konto i 192x-serien: {{code}}.',
  'investments.bankName': 'Kontonavn',
  'investments.bankNamePlaceholder': 'F.eks. Investeringskonto',
  'investments.bankAccountNumber': 'Kontonummer',
  'investments.openingBalance': 'Startsaldo',
  'investments.openingBalanceDate': 'Dato for startsaldo',
  'investments.bankNameRequired': 'Giv bankkontoen et navn.',
  'investments.bankNumberRequired': 'Udfyld kontonummer.',
  'investments.bankOpeningRequired': 'Udfyld startsaldo og dato for startsaldo. Skriv 0, hvis saldoen var nul.',
  'investments.bankNumberExists': 'Bankkontoen er allerede registreret.',
  'investments.bankLedgerSeriesFull': 'Der findes ingen ledig konto i 192x-serien. Tilføj kontoen i Indstillinger.',
  'investments.bankAdded': 'Bankkonto tilføjet.',
  'investments.addBankFailed': 'Bankkontoen kunne ikke tilføjes.',
  'investments.addBankUnavailable': 'Bankkonti er ikke forbundet til backend.',
  'investments.addBankUnsupportedCountry': 'Dette bankkontoforløb understøttes indtil videre kun for norske virksomheder.',
  'investments.newInvestmentAccount': 'Ny investeringskonto',
  'investments.investmentAccounts': 'Investeringskonti og depoter',
  'investments.settingsTab': 'Investeringer',
  'investments.settingsTitle': 'Investeringskonti og depoter',
  'investments.settingsHelp': 'Administrér kontiene hos banker, fondsudbydere og andre udbydere.',
  'investments.editInvestmentAccount': 'Redigér investeringskonto',
  'investments.investmentAccountsHelp': 'Registrér kontiene hos hver udbyder. Den samme investering kan ejes i flere depoter, mens hovedbogskontoen fortsat er firecifret.',
  'investments.noInvestmentAccounts': 'Der er endnu ikke registreret nogen investeringskonti.',
  'investments.saveInvestmentAccount': 'Gem investeringskonto',
  'investments.investmentAccountId': 'Bank / depot',
  'investments.targetInvestmentAccountId': 'Ny bank / depot',
  'investments.accountNumber': 'Konto- eller depotnummer (valgfrit)',
  'investments.defaultSettlementAccount': 'Standardafregningskonto',
  'investments.noDefaultSettlementAccount': 'Ingen standardafregningskonto',
  'investments.accountActive': 'Investeringskontoen er aktiv',
  'investments.custody': 'Værdipapirdepot',
  'investments.fund_account': 'Fondskonto',
  'investments.other': 'Anden investeringskonto',
  'investments.subledgerCode': 'Internt investeringsnummer',
  'investments.createInstrumentFromDocument': '{{name}} (oprettes, når du gemmer)',
  'investments.providerHelp': 'Hvor investeringen opbevares, for eksempel Storebrand eller Nordnet. Angiv gerne depotnummer, når det er relevant.',
  'investments.settlementAccountHelp': 'Virksomhedens konto, der blev debiteret eller krediteret. En handelskonto hos udbyderen skal registreres som en separat bank-/afregningskonto i Indstillinger. Et AS kan ikke bruge en privat aksjesparekonto (ASK).',
  'investments.investmentAccountInvalid': 'Kontrollér navn, udbyder og kontotype.',
  'investments.investmentAccountNotFound': 'Investeringskontoen findes ikke eller er inaktiv.',
  'investments.investmentAccountDuplicate': 'Der findes allerede en investeringskonto med samme navn.',
  'investments.investmentAccountRequired': 'Vælg investeringskonto, når udbyderen har flere konti.',
  'investments.investmentAccountQuantityInvalid': 'Det valgte depot har ikke nok registrerede andele til hændelsen.',
});
